export const FETCH_PROD_OPTIONS = 'app/productConfig/FETCH_PROD_OPTIONS';
export const RESET_MODULE = 'app/productConfig/RESET_MODULE';
export const FETCH_PRODUCT_OPTION_GROUPS =
  'app/productConfig/FETCH_PRODUCT_OPTION_GROUPS';
export const FETCH_PRODUCT_NEAR_USER =
  'app/productConfig/FETCH_PRODUCT_NEAR_USER';
